'use client';
import { Box } from '@mui/material';
import { useTranslations } from 'next-intl';

import {
    DigitalhubDivider,
    EchtDigitalLogo,
    FilledButton,
    Footer,
    HandshakeIcon,
    HubIcon,
    SHStateChancelleryLogo,
    WTSHLogo
} from '@dh/components';
import { useBreakpoint } from '@dh/hooks';
import {
    BodyLarge,
    BodyMedium,
    BodySmall,
    Center,
    DisplayMedium,
    DisplaySmall,
    WrapContainer
} from '@dh/styles';
import { getBreakpointValue, isExpanded, isMedium } from '@dh/types';

import { ROUTES } from '../../../../constants';
import { BannerBox, BannerRow, BottomSectionContainer } from './styles';

const LandingPageRegistrationBannerSection = () => {
    const t = useTranslations('landing_page');
    const breakpoint = useBreakpoint();

    const iconSize = getBreakpointValue(breakpoint, 48, 96, 136);

    const isExpandedLayout = isExpanded(breakpoint);
    const isMediumLayout = isMedium(breakpoint);

    const renderBannerText = () => {
        const title = t('registration_banner_title');
        const text = t('registration_banner_description');
        if (isExpandedLayout)
            return (
                <>
                    <DisplayMedium color='white'>{title}</DisplayMedium>
                    <BodyLarge maxWidth={500} color='white'>
                        {text}
                    </BodyLarge>
                </>
            );
        else if (isMediumLayout)
            return (
                <>
                    <DisplayMedium color='white'>{title}</DisplayMedium>
                    <BodyMedium color='white'>{text}</BodyMedium>
                </>
            );
        else
            return (
                <>
                    <DisplaySmall color='white'>{title}</DisplaySmall>
                    <BodySmall color='white'>{text}</BodySmall>
                </>
            );
    };

    return (
        <BottomSectionContainer mt={getBreakpointValue(breakpoint, 5, 10, 15)}>
            <BannerRow breakpoint={breakpoint}>
                {isExpandedLayout && (
                    <>
                        <Center maxWidth={'30%'}>
                            <Box height={250} />
                            <DigitalhubDivider isWhite />
                            <BannerBox breakpoint={breakpoint}>
                                <HandshakeIcon
                                    width={iconSize.toString()}
                                    height={iconSize.toString()}
                                />
                            </BannerBox>
                        </Center>
                        <DigitalhubDivider isWhite orientation='vertical' />
                    </>
                )}
                <BannerBox gap={3} px={3} pt={5} breakpoint={breakpoint}>
                    {renderBannerText()}

                    <FilledButton label={t('sign_in')} href={ROUTES.Login} />
                </BannerBox>
                {isExpandedLayout && (
                    <>
                        <DigitalhubDivider isWhite orientation='vertical' />
                        <Center maxWidth={'30%'}>
                            <BannerBox breakpoint={breakpoint}>
                                <HubIcon width={iconSize.toString()} height={iconSize.toString()} />
                            </BannerBox>
                        </Center>
                    </>
                )}
                <WrapContainer
                    gap={4}
                    my={isExpandedLayout ? 0 : 10}
                    mr={3}
                    height={'100%'}
                    alignContent={'flex-end'}
                    sx={{ gridColumn: '1/6', justifyContent: 'flex-end' }}
                >
                    <EchtDigitalLogo />
                    <SHStateChancelleryLogo />
                    <WTSHLogo />
                </WrapContainer>
            </BannerRow>
            <Footer isLandingPage />
        </BottomSectionContainer>
    );
};

export { LandingPageRegistrationBannerSection };
